// extracted by mini-css-extract-plugin
export var alertIcon = "_mw-0";